function assertIsNotNullOrUndefined(prototypeFuncName: string, thisValue: any) {
	if (thisValue == null) {
		throw new TypeError(`Array.prototype.${prototypeFuncName} called on null or undefined`);
	}
}

Array.prototype.flatMap = Array.prototype.flatMap || function (this: Array<any>, mapFunc: any, thisArg?: any) {

	assertIsNotNullOrUndefined('flatMap', this);

	return ([] as Array<any>).concat(...this.map(mapFunc, thisArg));
};

Array.prototype.includes = Array.prototype.includes || function (this: Array<any>, value: any, fromIndex?: number) {

	assertIsNotNullOrUndefined('includes', this);

	return this.indexOf(value, fromIndex) !== -1;
};

Array.prototype.find = Array.prototype.find || function (this: Array<any>, predicate: any, thisArg?: any) {

	assertIsNotNullOrUndefined('find', this);

	for (let i = 0; i < this.length; i++)
		if (predicate.call(thisArg, this[i], i, this))
			return this[i];

	return undefined;
};

Array.prototype.findIndex = Array.prototype.findIndex || function (this: Array<any>, callback: any, thisArg: any) {
	assertIsNotNullOrUndefined('findIndex', this);

	for (let i = 0; i < this.length; i++)
		if (callback.call(thisArg, this[i], i, this))
			return i;

	return -1;
};

Array.prototype.remove = Array.prototype.remove || function (this: Array<any>, value: any) {

	assertIsNotNullOrUndefined('remove', this);

	const index = this.indexOf(value);
	if (index !== -1)
		this.splice(index, 1);
};

Array.prototype.except = Array.prototype.except || function (this: Array<any>, otherArray: Array<any>) {

	assertIsNotNullOrUndefined('except', this);

	return this.filter(item => otherArray.indexOf(item) < 0);
};

Array.prototype.moveItem = Array.prototype.moveItem || function (this: Array<any>, fromIndex: number, toIndex: number): void {

	assertIsNotNullOrUndefined('moveItem', this);

	const isBetween = (x: number, from: number, to: number) => x >= from && x <= to;
	const minBound = 0;
	const maxBound = this.length + 1;

	if (!isBetween(fromIndex, minBound, maxBound))
		throw new Error('fromIndex no se encuentra dentro de los intervalos del Array');

	if (!isBetween(fromIndex, minBound, maxBound))
		throw new Error('toIndex no se encuentra dentro de los intervalos del Array');

	if (fromIndex === toIndex)
		return;

	this.splice(toIndex, 0, this.splice(fromIndex, 1)[0]);
};

Array.prototype.groupBy = Array.prototype.groupBy || function <TKey, TElement>(this: Array<any>, keySelector: (value: any) => TKey, elementSelector?: (value: any) => TElement, keyComparer?: (key1: TKey, key2: TKey) => boolean) {

	assertIsNotNullOrUndefined('groupBy', this);

	type Group = { key: TKey, value: TElement[] };

	const groups: Group[] = [];

	return this.reduce(function (groups: Group[], item: any) {

		const key = keySelector(item);
		const element = elementSelector ? elementSelector(item) : item;
		const comparer = keyComparer || ((key1: TKey, key2: TKey) => key1 === key2);

		const existingGroup = groups.find(x => comparer(x.key, key));
		if (existingGroup)
			existingGroup.value.push(element);
		else
			groups.push({ key: key, value: [element] });

		return groups;

	}, groups);

};

Array.prototype.sortBy = Array.prototype.sortBy || function <TElement>(
	this: Array<TElement>,
	sortCriteria: (item: TElement) => any,
	sortDirection?: 'asc' | 'desc',
	thenBy?: (item: TElement) => any,
	thenByDirection?: 'asc' | 'desc'): TElement[] {

	assertIsNotNullOrUndefined('sortBy', this);

	const array: TElement[] = [...this];

	const mult = (!sortDirection || sortDirection === 'asc') ? 1 : -1;
	const thenMult = (!thenByDirection || thenByDirection === 'asc') ? 1 : -1;

	array.sort((e1, e2) => {

		const s1 = sortCriteria(e1);
		const s2 = sortCriteria(e2);

		if (s1 < s2) return -1 * mult;
		if (s1 > s2) return 1 * mult;

		if (!thenBy)
			return 0;

		const t1 = thenBy(e1);
		const t2 = thenBy(e2);

		if (t1 < t2) return -1 * thenMult;
		if (t1 > t2) return 1 * thenMult;

		return 0;
	});
	return array;
};

Array.prototype.partition = Array.prototype.partition || function <TElement>(this: Array<TElement>, size: number): TElement[][] {

	assertIsNotNullOrUndefined('partition', this);

	const partitions = [];
	const temp = [...this];

	while (temp.length > 0)
		partitions.push(temp.splice(0, size));

	return partitions;
};

function identity<T>(t: T) {
	return t as any;
}

Array.prototype.sum = Array.prototype.sum || function sum<TElement>(this: Array<TElement>, selector: (value: TElement) => number = identity): number {

	assertIsNotNullOrUndefined('sum', this);

	return this.map(x => selector(x)).reduce((x, y) => x + y, 0);
};

Array.prototype.last = Array.prototype.last || function <TElement>(this: Array<TElement>): TElement | null {
	assertIsNotNullOrUndefined('last', this);

	return this.length > 0 ? this[this.length - 1] : null;
};

export { };